module.exports = __webpack_public_path__ + "static/media/map-pin.fbec3996.svg";